import { render, staticRenderFns } from "./stampList.vue?vue&type=template&id=3b6e0a1f&scoped=true"
import script from "./stampList.vue?vue&type=script&lang=js"
export * from "./stampList.vue?vue&type=script&lang=js"
import style0 from "./stampList.vue?vue&type=style&index=0&id=3b6e0a1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6e0a1f",
  null
  
)

export default component.exports